module.exports = __webpack_public_path__ + "img/action.3a1c8274.png";